import { render } from "./Select.vue?vue&type=template&id=04454cb8&scoped=true&ts=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=04454cb8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04454cb8"]])

export default __exports__